import { applyConcede } from "@cloudnest/stone-flicking-core-engine/appliers";
import type { SurrenderAction } from "../types/actions";
import type { StoneFlickingState } from "../types/game-state";
import { toParticipantId, wrapCoreState } from "../utils/state-mapper";

export function applySurrender(
  state: StoneFlickingState,
  action: SurrenderAction,
): StoneFlickingState {
  const coreAction = {
    type: "CONCEDE" as const,
    participantId: toParticipantId(action.playerId),
  };

  const nextCoreState = applyConcede(state.coreState, coreAction);
  return wrapCoreState(nextCoreState);
}
